import { useQuery } from '@tanstack/react-query';
import { fetchPracticeStats } from '../services/practiceStats';
import { PRACTICE_STATS_KEY } from './queryKeys';

// The Overview tab only mounts this (via usePracticeStats) while it's the
// active tab (see PracticeDetail.tsx) - mounting IS the "tab is active"
// signal, same gating as the Patients/Communications tabs' own hooks.
export function usePracticeStats(practiceId: string | undefined) {
    const query = useQuery({
        queryKey: PRACTICE_STATS_KEY(practiceId ?? ''),
        queryFn: () => fetchPracticeStats(practiceId as string),
        enabled: Boolean(practiceId),
        staleTime: 60_000
    });

    return {
        stats: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}
